var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationOutline = function SvgNotificationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.972 27.662c3.198-4.26 3.557-10.516 3.583-11.077.701-5.849 3.67-9.34 7.945-9.34 4.276 0 7.245 3.491 7.946 9.34.026.56.385 6.817 3.583 11.077H5.972ZM17.5 30.943c-1.153 0-2.13-.77-2.444-1.823h4.889a2.556 2.556 0 0 1-2.445 1.823Zm13.638-3.07c-3.88-3.836-4.233-11.303-4.236-11.377a.965.965 0 0 0-.004-.056c-.686-5.787-3.562-9.642-7.665-10.48a1.8 1.8 0 0 0 .09-.537 1.823 1.823 0 1 0-3.645 0c0 .188.037.366.09.538-4.103.837-6.978 4.692-7.664 10.478a.728.728 0 0 0-.005.057c-.003.074-.356 7.541-4.236 11.377a.729.729 0 0 0 .512 1.247h9.185a4.014 4.014 0 0 0 3.94 3.282 4.015 4.015 0 0 0 3.941-3.282h9.184a.729.729 0 0 0 .513-1.247Z",
    fill: "currentColor"
  })));
};
export default SvgNotificationOutline;